import { Constants } from './constants';
import UrlFactory from './url_factory';
import axios from 'axios';

class API extends UrlFactory {
    static _instance = null;
    static Instance() {
        if (!API._instance) {
            API._instance = new API();
        }
        return API._instance;
    }

    makeHeaders() {
        return {
            method: 'GET',
            credentials: 'include',
        };
    }

    makeClockoutHeaders() {
        return {
            headers: { token: Constants.CONSUMER_AUTH_TOKEN },
            validateStatus: function (status) {
                return status === 200 || status === 304 || status === 404; // Resolve only if the status code is 200 or 304
            },
        };
    }

    async fetchContext(nonce) {
        const response = await axios.get(this.createContextUrl(nonce), this.makeHeaders());
        return response.data;
    }
}

export default API;
